/**
 * Final-evaluation failure screen.
 */
import React from "react";
import { useTranslation } from 'react-i18next';

import { VButton } from "form";

/**
 * Shows a failed final-exam result.
 *
 * @param {{ onRestart?: Function }} props
 */
const FinalFailure = (props) => {

  const { totalCount, successCount, onRestartClick } = props;

  const { t } = useTranslation('common');

  return <>
    <div className="w-full">
      <div className="flex items-center flex-col shadow mt-5 p-4">
        <img className="w-20 h-20" src="https://files.plateformedoctonet.com/app-eduforma/sadicon-removebg-preview.png" alt="" />
        <p className="font-bold fsp-18 text-muted mt-4">
          {t("Ooops, you didn't pass the quiz but you can try it again!")}
        </p>
        <p className="text-base">
          {t('Your score')}:&nbsp;
          {successCount}&nbsp;
          {t('correct answers and')}&nbsp;
          {totalCount - successCount}
          {t('incorrect answers')}
        </p>
        <VButton onClick={onRestartClick} variant="contained">
          {t('Repeat your assessment')}
        </VButton>
      </div>

    </div>
  </>
}

export default FinalFailure;